import { CaretDownFilled, CaretUpFilled } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import * as theme from "./Sorter.css";

import "../../styles/main.less";

interface SorterProps {
    sortDirection: "asc" | "desc" | false;
}
/**
Used for sorting table columns.
*/
export function Sorter({ sortDirection }: SorterProps) {
    return (
        <div className={theme.sorter}>
            <CaretUpFilled
                className={cx(
                    sortDirection === "asc" && theme.caretActive,
                    theme.caret
                )}
            />
            <CaretDownFilled
                className={cx(
                    sortDirection === "desc" && theme.caretActive,
                    theme.caret
                )}
            />
        </div>
    );
}
